import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { currentPersonSelector } from "@/pages/ContactsPage/slice/";
import { useAppSelector } from "@/services/store";
import { NoContactsPage } from "../../Components/NoContactsPage";
import styles from "../styles.module.scss";
import { ControlButtons } from "../../Components/ControlButtons";
import { Layout } from "./Components/Layout";
import { GeneralInfoTabForm } from "./Components/GeneralInfoTabForm";

export const GeneralInfoTab = () => {
  const { t } = useTranslation();

  const currentPerson = useAppSelector(currentPersonSelector);

  if (!currentPerson) return <NoContactsPage message={t("contactsPage.noSelected")} />;

  return (
    <GeneralInfoTabForm defaultValuesPerson={currentPerson}>
      <div className={classNames(styles.root, styles["tab-container"])}>
        <Layout />
        <div className={styles["buttons-container"]}>
          <ControlButtons tabType="generalInfo" />
        </div>
      </div>
    </GeneralInfoTabForm>
  );
};
